import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastDescriptionFn = /* @__PURE__ */ createRecipe('toast-description', {}, [])

const toastDescriptionVariantMap = {}

const toastDescriptionVariantKeys = Object.keys(toastDescriptionVariantMap)

export const toastDescription = /* @__PURE__ */ Object.assign(memo(toastDescriptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastDescription',
  __getCompoundVariantCss__: toastDescriptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastDescriptionVariantKeys,
  variantMap: toastDescriptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastDescriptionVariantKeys)
  },
  getVariantProps: toastDescriptionFn.getVariantProps,
})